module.exports = __webpack_public_path__ + "media/images/crypto-currencies/euro-531598af7078994f297281fad42e23f6.svg";